<template>
  <div style="text-align: left">
    <div v-if="this.$store.state.CurrentUser === 'reader'"> {{ comment != null ? comment : '还未添加任何备注' }} </div>
    <div v-else>
      <p v-if="!editMode" style="cursor: pointer" @click="toggleEdit" v-html="comment != null ? processNewLines(comment) : '还未添加任何备注'"></p>
      <div v-else>
        <el-input
          type="textarea"
          :rows="3"
          placeholder="请输入内容"
          v-model="comment">
        </el-input>
        <el-button type="primary" style="margin-top: 10px;" @click="onSave">保存</el-button>
      </div>
    </div>
  </div>

</template>

<script>
import * as api from "@/js/api.js";

export default {
  name: "Comment",

  props: {
    providerInfo: Object
  },

  data() {
    return {
      editMode: false,
      comment: null,
    }
  },

  methods: {
    processNewLines(input) {
      return input.replaceAll('\r\n', '\n').replaceAll('\n', '<br/>')
    },

    toggleEdit() {
      this.editMode = !this.editMode
    },

    onSave() {
      const params = {
        providerId: this.providerInfo.id,
        comment: this.comment
      }

      api.providerUpdateBasicInfo(params).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error(result.error)
        } else {
          this.$message.success('操作成功')
          this.providerInfo.comment = this.comment
          this.editMode = false
        }
      })
    }
  },
  mounted() {
    this.comment = this.providerInfo.comment
  },

  watch: {
    'providerInfo': function (val) {
      this.comment = val.comment
    }
  },
}
</script>

<style scoped>

.pagination {
  margin-top: 15px;
}

</style>



// WEBPACK FOOTER //
// src/pages/providers/comment/Comment.vue